import { PhnxButton } from '@/components/01-atoms/Button/Button'
import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import { PhnxSectiontitle } from '../../01-atoms/Sectiontitle/Sectiontitle'
import styles from './Featurecards.module.css'

export type FeaturecardsProps = {
  title?: string
  description?: React.ReactNode
  layout?: 'primary' | 'secondary'
  items?: {
    title?: string
    asset?: {
      src?: string
      alt?: string
    }
    link?: string
    content?: string
    linkLabel?: string
  }[]
  button?: React.ReactNode
} & StylePanelProps

export const PhnxFeaturecards: React.FC<FeaturecardsProps> = ({
  layout = 'primary',
  title,
  description,
  items,
  button,
  padding,
  backgroundColor,
  textColor,
  alignment = 'center',
}) => {
  const paddingStyles = useResponsivePadding(padding)

  const style = {
    ...paddingStyles,
    backgroundColor,
    color: textColor,
  }

  return (
    <div style={style} className="stylepanel">
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      <div
        className={`${styles['featurecards']} ${styles[`alignment-${alignment}`]} ${styles[`layout-${layout}`]} container`}
      >
        {/* {title && (
          <div className={styles.title}>
            {layout === 'primary' && <h2>{title}</h2>}
            {layout === 'secondary' && <p className="title">{title}</p>}
          </div>
        )}
        {description && <div className={styles.description}>{description}</div>} */}

        {layout === 'primary' && (
          <PhnxSectiontitle
            title={title ? title : ''}
            subtitle={description ? description : ''}
            variant={'primary'}
          />
        )}

        {layout === 'secondary' && (
          <PhnxSectiontitle
            title={title ? title : ''}
            subtitle={description ? description : ''}
            variant={'quaternary'}
          />
        )}

        <div className={styles['feature-card-container']}>
          {items &&
            items.length > 0 &&
            items.map((item, index) =>
              item.link ? (
                <a key={index} href={item.link} className={styles.item}>
                  {layout === 'primary' && (
                    <div className={styles.asset}>
                      <img src={item.asset?.src} alt={item.asset?.alt} />
                    </div>
                  )}
                  <div className={styles.content}>
                    {layout === 'secondary' && (
                      <div className={styles.asset}>
                        <img src={item.asset?.src} alt={item.asset?.alt} />
                      </div>
                    )}
                    <h3>{item.title}</h3>
                  </div>
                  {item.content && <div className={styles.itemdes}>{item.content}</div>}
                  {layout !== 'primary' && (
                    <PhnxButton
                      type="button"
                      label={item.linkLabel ? item.linkLabel : 'Learn more'}
                      variant="quinary"
                    />
                  )}
                </a>
              ) : (
                <div key={index} className={styles.item}>
                  {layout === 'primary' && (
                    <div className={styles.asset}>
                      <img src={item.asset?.src} alt={item.asset?.alt} />
                    </div>
                  )}
                  <div className={styles.content}>
                    {layout === 'secondary' && (
                      <div className={styles.asset}>
                        <img src={item.asset?.src} alt={item.asset?.alt} />
                      </div>
                    )}
                    <h3>{item.title}</h3>
                  </div>
                  {item.content && <div className={styles.itemdes}>{item.content}</div>}
                </div>
              )
            )}
        </div>
        {button && <div className={styles.button}>{button}</div>}
      </div>
    </div>
  )
}
